import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { Autoplay } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let animationId: any = null;
const duration = 3000; // 动画持续时间（毫秒）
let initAniTime = 0; // 开启动画的时间
let aniFrameTime = 0; // 每一帧动画进入时间

export default function B() {
    const { useLang, useEffect, useState, useRouter, Link } = useGlobal();
    const { t } = useLang('offgrid');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    // const swiper = useSwiper(); // 版本太低无法使用
    const [swiper, setSwiper] = useState(null);

    const cards: any = [
        {
            img: `/responsive/picture/off-grid/2_1`,
            tag: t('secB_card1_tag'),
        },
        {
            img: `/responsive/picture/off-grid/2_2`,
            tag: t('secB_card2_tag'),
        },
        {
            img: `/responsive/picture/off-grid/2_3`,
            tag: t('secB_card3_tag'),
        },
        {
            img: `/responsive/picture/off-grid/2_4`,
            tag: t('secB_card4_tag'),
        },
    ];
    const element = typeof window === 'undefined' ? null : (document.querySelector('.off-grid-B .btn .circle circle') as SVGCircleElement);

    const handlePrev = () => {
        swiper.slidePrev();
    };

    const handleNext = () => {
        swiper.slideNext();
    };

    const handleSlideChange = () => {
        initAniTime = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        doAnimate();
    };

    // 执行动画的函数
    const animate = (_currentTime: number) => {
        if (!initAniTime) {
            initAniTime = new Date().getTime();
        }
        aniFrameTime = new Date().getTime();

        // 计算动画进度（0 到 1 之间的值）
        if (element && swiper) {
            const judgeTime = aniFrameTime - initAniTime;
            const progress = Math.min(judgeTime / duration, 1);
            element.style.strokeDashoffset = `${100 - progress * 100}px`;
            if (judgeTime >= duration) {
                swiper.slideNext();
            }
            requestAnimationFrame(animate);
        }
    };

    const doAnimate = () => {
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            // window.addEventListener('resize', resetGap);
            // return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && swiper) {
            // 启动动画
            // doAnimate();
        }
    }, [swiper]);

    return (
        <div id="off-grid-B" className={`off-grid-B off-grid-box ${css['off-grid-B']}`}>
            <div className="inner-box">
                <div className="text-info">
                    <h2 className="title">{t('secB_title')}</h2>
                    <p className="desc">{t('secB_desc')}</p>
                    <div className="btns">
                        <span className="btn prev" onClick={handlePrev}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
                                <g clipPath="url(#clip0_35_6276)">
                                    <circle cx="27" cy="27" r="27" transform="matrix(-1 0 0 1 54 0)" fill="#F4F4F4" />
                                    <path d="M29.25 33.75L22.5 27L29.25 20.25" stroke="black" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_35_6276">
                                        <rect width="54" height="54" fill="white" transform="matrix(-1 0 0 1 54 0)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span className="btn next" onClick={handleNext}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
                                <g clipPath="url(#clip0_35_6279)">
                                    <circle cx="27" cy="27" r="27" fill="#F4F4F4" />
                                    <path d="M24.75 33.75L31.5 27L24.75 20.25" stroke="black" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_35_6279">
                                        <rect width="54" height="54" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <svg className="circle" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                                <circle
                                    cx="18"
                                    cy="18"
                                    r="16"
                                    fill="transparent"
                                    stroke="#3F68E0"
                                    strokeWidth="2"
                                    strokeDashoffset="100"
                                    strokeLinecap="round"
                                    strokeDasharray="100 100"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
                <div className="cards">
                    <Swiper
                        className="swiper-box"
                        // modules={[Navigation, Pagination]}
                        modules={[Autoplay]}
                        spaceBetween={gap}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        onSwiper={(swipwerIns: any) => setSwiper(swipwerIns)}
                        loop
                        // autoplay={{  => 改为由动画驱动（否则轮播时间与动画时间会出现误差）
                        //     delay: 4000,
                        //     disableOnInteraction: false,
                        // }}
                        onSlideChange={handleSlideChange}
                    >
                        {cards?.map((card: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                <div className="card-img">
                                    <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_768.jpg`} srcMobile={`${card?.img}_768.jpg`} alt={card?.tag} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
